import React, { createContext, useContext, useState, ReactNode } from 'react'

interface TourContextType {
  isTourRunning: boolean
  startTour: () => void
  stopTour: () => void
}

const TourContext = createContext<TourContextType | undefined>(undefined)

export function TourProvider({ children }: { children: ReactNode }) {
  const [isTourRunning, setIsTourRunning] = useState(false)

  const startTour = () => {
    setIsTourRunning(true)
  }

  const stopTour = () => {
    setIsTourRunning(false)
  }

  return (
    <TourContext.Provider value={{ isTourRunning, startTour, stopTour }}>
      {children}
    </TourContext.Provider>
  )
}

export function useTour() {
  const context = useContext(TourContext)
  if (context === undefined) {
    throw new Error('useTour must be used within a TourProvider')
  }
  return context
}
